module.exports = __webpack_public_path__ + "img/virtual_fan_3.b061a75.jpg";